module.exports = __webpack_public_path__ + "img/wifi.d35ec1f4.gif";